.arrow {
	color: var(--color-text-subtle);
}

.details {
	padding-inline-start: var(--size-6);
}

.iconName {
	flex: 1;
	display: flex;
	align-items: center;
	gap: var(--size-3);
	min-width: 0;
}

.name {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.note {
	margin: 0;
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}
